import { useEffect } from "react";
import { _CreditAccount } from "../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { Amortizacion } from "./Amortizacion";


export const RequestCredit=()=>{

    const instance = useDataBean(_CreditAccount);
    const {lista,setLista,bean,setBean} = instance;
    const modalAmortizacion = useModal("Proyección",MODAL_md);

    useEffect(()=>{
        getRequestCreditRender();
    },[])

    const getRequestCreditRender=()=>{
        instance.instance.getRequestCreditRender(1,1000,{}).then(
            (resp:any)=>{
                setLista(resp.List);
            }
        )
    }

      const head = [
        {title:'ID',property:'IDRequestCredit',visible:true,mask:MASK_NUMBER},
        {title:'Solicitud',property:'AlphaCode',visible:true},
        {title:'Nit',property:'Nit',visible:true},
        {title:'Solicitante',property:'EntityName',visible:true},
        {title:'Monto',property:'AmountCredit',visible:true},
        {title:'Interes',property:'AmountTax',visible:true},
        {title:'Cuotas',property:'Cuotes',visible:true},
        {title:'Estado',property:'StateRequestName',visible:true}        
    ]
     const listaBotones =()=>{
        const botones = [
            {titulo:'Proyectar Amortización',icono:'ri-file-add-line',visible:true,evento:()=>{modalAmortizacion.open()}},
           

        ]
        return(
            <ListMenu listaBotones={botones}/>
        )
    }


    return(
        <BasicPage titulo="Solicitudes">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean}></BasicTable>
                    <Modal modal={modalAmortizacion.modal} updateModal={modalAmortizacion.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <Amortizacion beanRequestCredit={bean}/>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}